import React from 'react';
import { ReactComponent as VisaIcon } from '../../../../assets/paymentMethods/card-brand/visa.svg';
import { ReactComponent as MastercardIcon } from '../../../../assets/paymentMethods/card-brand/mastercard.svg';
import { ReactComponent as AmexIcon } from '../../../../assets/paymentMethods/card-brand/amex.svg';
import { CARD_BRAND } from '../../../../constants/types';

const CardBrand = ({ cardBrand }) => {
  if (!cardBrand) {
    return null;
  }

  const getCardBrandIcon = () => {
    switch (cardBrand) {
      case CARD_BRAND.VISA:
        return <VisaIcon className="cardBrandIcon" />;
      case CARD_BRAND.MASTERCARD:
        return <MastercardIcon className="cardBrandIcon" />;
      case CARD_BRAND.AMERICAN_EXPRESS:
        return <AmexIcon className="cardBrandIcon" />;
      default:
        return null;
    }
  };

  return getCardBrandIcon();
};

export default CardBrand;
